import { useEffect } from 'react';
import { App } from 'antd';

import { AIProps } from '../service/ai.interface';
import { useCreateAIMutation } from '../service/ai';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const useCreatePrompt = () => {
    const current = useAppSelector(selectShopCurrent);
    const { notification } = App.useApp();
    const [createPrompt, { isLoading, isSuccess }] = useCreateAIMutation();

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Успешно сохранено',
            });
        }
    }, [isSuccess]);

    const submit = async (values: AIProps) => {
        const payload = {
            id: current.id,
            ...values,
        };
        await createPrompt(payload);
    };

    return { isLoading, isSuccess, submit };
};
